import { render, staticRenderFns } from "./ColoredTag.vue?vue&type=template&id=cd90bf9e&scoped=true"
import script from "./ColoredTag.vue?vue&type=script&lang=js"
export * from "./ColoredTag.vue?vue&type=script&lang=js"
import style0 from "./ColoredTag.vue?vue&type=style&index=0&id=cd90bf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd90bf9e",
  null
  
)

export default component.exports